import React from "react";
import logo from "../assets/logo_fogsolution.png";
import logoApp from "../assets/drop2.png";
import appStore from "../assets/appstore.svg";
import googlePlay from "../assets/playstore.svg";
import "../App.css";
import { Button } from "@chakra-ui/react";
import { LuDownload, LuExternalLink } from "react-icons/lu";
import { Link } from "react-router-dom";
import { YoutubeCarousel } from "../Components/YoutubeCarousel";
import SocialDisplay from "../Components/SocialDisplay";
import { updateFavicon, updateTitle } from "../Risorse/utils";
import routes from "../Risorse/routes";
import { useEffect } from "react";
import { useResources } from "../Providers/ResourcesProvider/ResourceProvider";

function FogSolutionLanding() {
  const { texts, language } = useResources();

  useEffect(() => {
    const normalizedTitle = String(texts.title ?? "")
      .replace(/\s+/g, " ")
      .trim();

    document.title = normalizedTitle;
    document.documentElement.lang = language;

    updateFavicon("/favicons/fogsolution.ico");
    updateTitle(texts.title);
  }, [language, texts]);

  return (
    <div className="App-body">
      <div className="App-header">
        <img src={logo} alt="logo" />
        <h1 className="App-title">{texts.appTitle}</h1>
        <h2 className="App-subtitle">{texts.appSubtitle}</h2>
      </div>
      {/* card */}
      <div className="App-card">
        <div className="App-card-icon">
          <img src={logoApp} alt={texts.storeIconAlt} />
        </div>
        <div className="App-card-stores">
          <a
            target="_blank"
            href="https://apps.apple.com/it/app/fog-solution/id6759971838"
          >
            <img src={appStore} alt="logo" />
          </a>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=it.zepping.nebulaapp"
          >
            <img src={googlePlay} alt="" />
          </a>
        </div>
        {/* <a href="about:blank" style={{ textDecoration: "underline" }}>
          {texts.downloadApk}
        </a> */}
      </div>
      {/* instructions section */}
      <div className="container">
        <h2 className="App-title">{texts.instructionsTitle}</h2>
        <Button size="xl" lg={{ width: "80%" }} variant="solid" asChild>
          <a href="about:blank" className="button-content">
            {texts.textPdfButton} <LuDownload />
          </a>
        </Button>

        <div
          style={{
            position: "relative",
            paddingBottom: "45%",
            height: 0,
            width: "80%",
          }}
        >
          <iframe
            src="https://www.youtube.com/embed/VIDEO_ID"
            title="Video istruzioni"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              borderRadius: "10px",
            }}
            allowFullScreen
          />
        </div>
      </div>
      {/* youtube section */}
      <div className="container">
        <h2 className="App-title">{texts.otherTutorialsTitle}</h2>
        <YoutubeCarousel />
      </div>
      {/* website */}
      <div className="container">
        <h2 className="App-title">{texts.siteTitle}</h2>
        <p className="App-subtitle">{texts.siteSubtitle}</p>
        <Button lg={{ width: "80%" }} size="xl" variant="solid" asChild>
          <a href="about:blank" className="button-content">
            {texts.websiteCta} <LuExternalLink />
          </a>
        </Button>
      </div>
      {/* Socials */}
      <div className="container">
        <h2 className="App-title">{texts.socialTitle}</h2>
        <SocialDisplay />
      </div>
      {/* Privacy Policy */}
      <div style={{ marginBottom: 24 }}>
        <Link
          to={routes.fogsolutionPrivacyPolicy}
          className="inline-link"
          style={{ textDecoration: "underline" }}
        >
          {texts.privacyPolicyTitle}
        </Link>
      </div>
    </div>
  );
}

export default FogSolutionLanding;
